import { linkedinEditorialRawErrorCodeToErrorMessageMapping } from './linkedin/linkedin-editorial-raw-error-code-mapping';

export const isLinkedInEditorialError = code =>
  Object.prototype.hasOwnProperty.call(linkedinEditorialRawErrorCodeToErrorMessageMapping, code);
